import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lkd-footer',
  templateUrl: './footer.component.html',
  styles: []
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
